import { z } from 'zod';
// Playbook schema JSONB structure validators
/**
 * Conditional display logic for questions
 * - equals: Show when referenced question has specific value(s)
 * - isNotEmpty: Show when referenced question has any non-empty value
 */
const showWhenSchema = z
    .object({
    questionId: z.string(),
    equals: z.union([z.string(), z.array(z.string())]).optional(),
    isNotEmpty: z.boolean().optional(),
})
    .refine((data) => data.equals !== undefined || data.isNotEmpty === true, {
    message: "showWhen must have either 'equals' or 'isNotEmpty: true'",
});
const questionSchema = z.object({
    id: z.string(),
    number: z.string(),
    question: z.string(),
    description: z.string().optional(),
    fieldType: z.enum(['short_text', 'long_text', 'single_select', 'multi_select', 'rank']),
    displayAs: z
        .enum(['checkbox', 'radio', 'long_text_xl', 'image_select', 'multi_list', 'searchable_select'])
        .optional(),
    fieldSize: z.enum(['small', 'paragraph', 'extra_long', 'extra_large']).optional(),
    options: z.array(z.string()).optional(),
    optionImages: z.record(z.string(), z.string()).optional(),
    notes: z.string().optional(),
    showWhen: showWhenSchema.optional(),
    required: z.boolean().optional(), // Default true when not specified
});
const sectionSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().optional(),
    hint: z.string().optional(), // Instructional text shown before questions
    questions: z.array(questionSchema),
});
// Validator for the playbook's schema JSONB column
export const playbookSchemaValidator = z.array(sectionSchema);
// SLA configuration validator
const slaTaskSchema = z.object({
    business_days: z.number().int().positive(),
});
export const playbookSlaValidator = z.object({
    doer_brief_days: z.number().int().positive().optional(),
    doer_implementation_days: z.number().int().positive().optional(),
    tasks: z.record(z.string(), slaTaskSchema).optional(),
}).nullable();
//# sourceMappingURL=playbook.js.map